const beDateFormat = 'YYYY-MM-DD HH:mm:ss';

const convertToArray = value => {
  return Array.isArray(value) ? value : [value];
};

// eslint-disable-next-line import/prefer-default-export
export const convertToSend = event => ({
  direction: event.direction,
  eventType: event.eventType,
  dateTime: event.dateTime && event.dateTime.format(beDateFormat),
  game: convertToArray(event.game),
  platform: convertToArray(event.platform),
  description: event.description,
  responsible: event.responsible,
  payload: {
    resolutionDate:
      event.resolutionDate && event.resolutionDate.format(beDateFormat),
    appVersion: event.appVersion,
    minAppVersion: event.minAppVersion,
    maxAppVersion: event.maxAppVersion,
    serverVersion: event.serverVersion,
    notesLink: event.notesLink,
    channel: event.channel,
    audience: event.audience,
    techTag: event.techTag,
    classTag: event.classTag,
    typeTag: event.typeTag,
    engineVersion: event.engineVersion,
  },
});
